export default "__VITE_ASSET__930017d6__"